import { render, staticRenderFns } from "./ReplyCount.vue?vue&type=template&id=0fcc6fb5&"
import script from "./ReplyCount.vue?vue&type=script&lang=js&"
export * from "./ReplyCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports